import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const AuthorInformation = ({ width = 40, height = 40, imageUrl, name, theme, count, authorLink }) => {
  const author = authorLink
    ? (
      <Link to={authorLink}>
        <div className={classNames(styles.name, 'link')}>{name}</div>
      </Link>
    )
    : <div className={styles.authorText}>{name}</div>;

  return (
    <div className={styles[`${theme}Theme`]}>
      <div className={styles.author}>
        <div className={styles.authorImage}>
          <CroppedImage
            width={width}
            height={height}
            src={imageUrl}
            alt={name} />
        </div>
        <div className={styles.information}>
          {author}
          {count && (
            <div className={styles.count}>
              {count}&nbsp;{pluralize(count, 'книга', 'книги', 'книг')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AuthorInformation.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  authorLink: PropTypes.object,
  count: PropTypes.number,
  theme: PropTypes.string,
};

export default AuthorInformation;
